export const siteInfo = {
  name: "每日黑料",
  tagline: "每日黑料大赛入口，黑料每日爆料，网红塌房现场直击",
  description: "每日黑料网✨聚焦每日黑料大赛入口、每日黑料吃瓜网最新地址，黑料每日爆料与网红塌房现场直击，每日更新吃瓜内容。每日黑料大赛，每日黑料吃瓜网，黑料每日，每日黑料最新地址，每日黑料入口，网红塌房，现场直击，吃瓜爆料。",
  keywords: "每日黑料,每日黑料大赛,每日黑料吃瓜网,黑料每日,每日黑料最新地址,每日黑料入口,网红塌房,现场直击,吃瓜爆料,每日黑料网",
  url: "https://www.meiriheiliao.com",
  foundedYear: 2023,
  email: "contact@meiriheiliao.com",
  phone: "400-888-6666",
  wechat: "meiriheiliao",
  weibo: "@每日黑料官方",
  address: "北京市朝阳区望京SOHO T1-B座 1808室",
  stats: {
    dailyVisitors: 1280000,
    totalArticles: 56800,
    registeredUsers: 3200000,
    monthlyPageViews: 98000000,
  },
};